import * as Inovx from '@shared';
import { apiPostForm } from '@shared/api/apiClient';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Measurement`;

interface IMeasurementApiData extends IVersionedItem {
    View360ID: string;
    KnowledgeViewID: string;
    Type: string;
    Coordinates: IVector3D[];
}

const createMeasurementApiFormData = (measurement: IMeasurementApiData) => {
    const form_data = new FormData();

    if (measurement.ID) form_data.append("ID", measurement.ID);
    if (measurement.VersionToken) form_data.append("VersionToken", measurement.VersionToken);

    if (measurement.View360ID) {
        form_data.append("View360ID", measurement.View360ID);
    }

    form_data.append("Name", measurement.Name);
    form_data.append("Type", measurement.Type);

    if (measurement.KnowledgeViewID) {
        form_data.append("KnowledgeViewID", measurement.KnowledgeViewID);
    }

    if (measurement.Coordinates) {
        for (let i = 0; i < measurement.Coordinates.length; i++) {
            form_data.append(`Coordinates[${i}].X`, measurement.Coordinates[i].X.toString());
            form_data.append(`Coordinates[${i}].Y`, measurement.Coordinates[i].Y.toString());
            form_data.append(`Coordinates[${i}].Z`, measurement.Coordinates[i].Z.toString());
        }
    }
    
    return form_data;
}

const MeasurementServices = { ...Inovx.Shared.Flux.BaseService,

    createMeasurement: async function (measurement: IMeasurementApiData) {
        const form_data = createMeasurementApiFormData(measurement);
        try {
            return await apiPostForm<IMeasurementApiData>(`${url}/Create`, form_data, { responseType: 'json' });
        }
        catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },

    editMeasurement: async function (measurement: IMeasurementApiData) {
        const form_data = createMeasurementApiFormData(measurement);
        
        try {
            return await apiPostForm<IMeasurementApiData>(`${url}/Update`, form_data, { responseType: 'json' });
        }
        catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },

    deleteMeasurement: function (measurement: IVersionedIdentityItem) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { ID: measurement.ID, VersionToken: measurement.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getMeasurement: function (id: string) {
        return new Promise<IMeasurementApiData>((resolve, reject) => {
            this.get(`${url}/ById`,
                { id } ,
                (retData: IMeasurementApiData) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getMeasurementsByView360: function (view360Id: string) {
        return new Promise<IMeasurementApiData[]>((resolve, reject) => {
            this.get(`${url}/ByView360`,
                { view360Id } ,
                (retData: IMeasurementApiData[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
};

export default MeasurementServices;